import Vue from 'vue'
import { getBrand, getBrandInfo } from '~utils/brand-provider'
import FileDownloader from '~utils/file-downloader'
import { getMetaEnvJson } from '~utils/meta'

const CURRENCIES: any = {
  eur: {
    iso: 'eur',
    symbol: '€',
    symbolFirst: false,
    space: true,
    name: 'Euro',
  },
  chf: {
    iso: 'chf',
    symbol: 'CHF',
    symbolFirst: true,
    space: true,
    name: 'Swiss Franc',
  },
}

interface Features {
  default: {
    [key: string]: boolean;
  };
  LH: {
    [key: string]: boolean;
  };
  OS: {
    [key: string]: boolean;
  };
  LX: {
    [key: string]: boolean;
  };
  SN: {
    [key: string]: boolean;
  };
  '4Y': {
    [key: string]: boolean;
  };
}

export default Vue.extend({
  computed: {
    brand() {
      return getBrand()
    },
    brandInfo() {
      return getBrandInfo()
    },
    brandSpecificKeys() {
      return new Set(Object.keys(require(`~locale/brands/${(this as any).brand}`).messages.en))
    },
  },
  methods: {
    formatPrice(price: number, currency: string) {
      const defaultBrandCurrency = this.brand === 'swiss' ? 'CHF' : 'EUR'
      const currencySettings = CURRENCIES[(currency || defaultBrandCurrency).toLowerCase()]

      if (currencySettings.symbolFirst) {
        return `${currencySettings.symbol}${currencySettings.space ? ' ' : ''}${(price / 100)}`
      }
      return `${(price / 100)}${currencySettings.space ? ' ' : ''}${currencySettings.symbol}`
    },
    formatPriceCents(price: any) {
      return (price / 100).toFixed(2)
    },
    translateSequenceMax(getKey: any, maxShownItems: any) {
      for (let i = 1; i < 100; i += 1) {
        const key = getKey(i)

        if (maxShownItems > 0 && i === maxShownItems) {
          return maxShownItems
        }

        if (!this.$te(key)) {
          return i - 1
        }
      }

      return 0
    },
    getTitleDescriptionItems(getKey: any, getDescription: any, maxItems = 0, format = {}) {
      const result = []

      for (let i = 1; i < 32; i += 1) {
        const titleKey = getKey(i)
        const item: any = {
          title: this.$te(titleKey) ? this.tr(titleKey, format) : null,
          descriptions: [],
        }

        if (maxItems > 0 && i > maxItems) {
          return result
        }

        for (let j = 0; j < 32; j += 1) {
          const descriptionKey: string = getDescription(i, j)

          if (this.$te(descriptionKey)) {
            item.descriptions.push(this.tr(descriptionKey, format))
          } else if (j > 1) {
            break
          }
        }

        // need at least title or one description
        if (item.title == null && item.descriptions.length === 0) {
          break
        }

        result.push(item)
      }

      return result
    },
    async downloadFile(url: string, payload: any) {
      await FileDownloader.download(url, payload)
    },
    tr(key: string, params: any) {
      if (this.$store.getters['locale/isEditing']) {
        const mode = this.$store.state.locale.currentLokaliseEditMode
        const isBrandSpecificKey = this.brandSpecificKeys.has(key)

        if (this.$store.state.locale.lokaliseEditingAuthenticated
          && ((isBrandSpecificKey && mode === 'Brand') || (!isBrandSpecificKey && mode === 'Common'))) {
          return `{.${key}.}`
        }
      }

      return `${this.$t(key, params)}`
    },
    featureEnabled(featureName: string) {
      const brandId = this.brandInfo.id

      const enabledFeatures = getMetaEnvJson('ENABLED_FEATURES') as Features | undefined
      if (enabledFeatures?.[brandId] && featureName in enabledFeatures[brandId]) {
        return enabledFeatures[brandId][featureName]
      }
      return !!(enabledFeatures?.default?.[featureName])
    },
  },
})
